const asyncLocalStorage = {
	setItem: (key, value) => new Promise(() => localStorage.setItem(key, value)),
	getItem: (key) =>
		new Promise((resolve) => resolve(localStorage.getItem(key))),
	removeItem: (key) => new Promise(() => localStorage.removeItem(key)),
};

export default asyncLocalStorage;
